import { GameScene } from "./gameScene";
declare let PhaserNavMeshPlugin: any;

const config: Phaser.Types.Core.GameConfig = {
	title: "Gam",
	type: Phaser.AUTO,
	render: {
		mipmapFilter: "LINEAR_MIPMAP_LINEAR"
	},
	width: 640,
	height: 640,
	physics: {
		default: "arcade",
		arcade: {
			debug: false
		}
	},
	plugins: {
		scene: [
			{
				key: "PhaserNavMeshPlugin", // Key to store the plugin class under in cache
				plugin: PhaserNavMeshPlugin, // Class that constructs plugins
				mapping: "navMeshPlugin", // Property mapping to use for the scene, e.g. this.navMeshPlugin
				start: true
			}
		]
	},
	scene: [GameScene]
};

window.onload = (): void => {
	const game: Phaser.Game = new Phaser.Game(config);
};
